import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, DropdownSelectField, InputNumberField } from '@jutro/legacy/components';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { TranslatorContext } from '@jutro/locale';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './TeachingOperationsComponent.module.scss';
import metadata from './TeachingOperationsComponent.metadata.json5';

function TeachingOperationsComponent(props) {

    const {
        data: TeachingOperationsVM,
        updateWizardData,
        submissionVM,
        TeachingOperationsPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addTeachingOperations = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            TeachingOperationsVM.value = TeachingOperationsVM.value || []

            const { _xCenter, _dtoName } = TeachingOperationsVM;

            const TeachingOperationsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            TeachingOperationsVM.pushElement(
                TeachingOperationsObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, TeachingOperationsVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            TeachingOperationsVM.value.splice(index, 1);
            _.set(submissionVM.value, TeachingOperationsPath, TeachingOperationsVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, TeachingOperationsPath, TeachingOperationsVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'namOfActDis1') {
                const value = item.namOfActDis1 ? item.namOfActDis1 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.namOfActDis1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'typ2') {
                const value = (item && item.typ2) ? item.typ2 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = TeachingOperationsVM.length > 0 && TeachingOperationsVM.children[index].typ2
                    // eslint-disable-next-line security/detect-object-injection
                    ? TeachingOperationsVM.children[index].typ2.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.typ2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'appNoOfStuPerYea3') {
                const value = item.appNoOfStuPerYea3 ? item.appNoOfStuPerYea3 : 0;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.appNoOfStuPerYea3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'appNoOfHouPerWee4') {
                const value = item.appNoOfHouPerWee4 ? item.appNoOfHouPerWee4 : 0;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.appNoOfHouPerWee4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'estAnnInc5') {
                const value = item.estAnnInc5 ? item.estAnnInc5 : {amount: 0, currency: "cad"};

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            val.amount = Math.max(0, val.amount);
                            item.estAnnInc5 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange, translator, TeachingOperationsVM.value])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`TeachingOperationsTable`]: {
            data: TeachingOperationsVM.value,
        }

    }), [TeachingOperationsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addTeachingOperations,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            TeachingOperationsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [TeachingOperationsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={TeachingOperationsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

TeachingOperationsComponent.propTypes = wizardProps;
export default withRouter(TeachingOperationsComponent);
